<template>
  <header>
    <button class="menu" @click="$store.commit('menu/menuToggle')"><i class="fas fa-times" v-if="menu"></i><i class="fas fa-bars" v-else></i></button>
    <h3>Old Header Title</h3>
    <button class="exit" @click="quit">X</button>
  </header>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    computed: {
      menu () {
        return this.$store.state.menu.menu
      }
    },
    methods: {
      quit() {
        this.$store.commit('scormLMS/scormScore', 7);
        this.$store.commit('scormLMS/scormComplete');
      }
    },
    components: {},
    props: ['items']
  }

</script>

<style scoped>
header {
  display: none;
}
button {
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// Top.vue?ac713b30